module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Bonnie Bryant\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Bonnie Bryant is the author of over one hundred forty books about horses, including the Saddle Club series and its spinoffs, the Pony Tails series and the Pine Hollow series. Bryant did not know very much about horses before writing the first Saddle Club book in 1986, so she found herself learning right along with the characters she created. She has also written novels and movie novelizations under her married name, Bonnie Bryant Hiller. Bryant was born and raised in New York City, where she still lives today."), _c('BR')], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/TXCmfs/tc-custom/9781497653399.jpg?1701351336889",
      "alt": "This image is the cover for the book Corey's Pony Is Missing, Pony Tails"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Corey's Pony Is Missing, Pony Tails\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Corey’s pony has run away, and it’s up to the Pony Tails to rescue him")]), _c('br'), _c('br'), _vm._v("Corey’s newly divorced parents are still working out which days Corey stays with each of them. Most weekends, Corey can be with her beloved pony, Samurai, and hang out with her best friends and neighbors, May and Jasmine. But this weekend, she is going to her dad’s, so she has asked her fellow Pony Tails to keep an eye on Samurai. Corey hates to leave, but she knows that no one could take better care of him than her two best friends."), _c('br'), _c('br'), _vm._v("Soon after Corey leaves, however, Sam disappears from his stall. May and Jasmine are desperate to find him. How could they have let Sam get away? The Pony Tails must solve the mystery of Samurai’s disappearance and get him back before something terrible happens.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Integrated Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0